import React from 'react'
import IconBase from 'react-icon-base'

export default props => (
  <IconBase viewBox="0 0 40 40" {...props}>
    <path
      d="M36,22.6c0-2.7-2.2-4.9-4.9-5C30.6,12.2,26.3,7.8,21,7.4c-3-0.2-5.9,0.8-8.2,2.9c-2,1.9-3.2,4.5-3.4,7.3
      c-2.7,0-4.9,2.2-4.9,5c0,2.7,2.2,5,5,5h0.9c0.6,0,1-0.4,1-1v-8v-0.3c0-2.5,1-4.8,2.8-6.5c1.8-1.7,4.2-2.5,6.7-2.4
      c4.6,0.3,8.3,4.3,8.3,9.2v8v3.2c0,0.9-0.7,1.6-1.6,1.6h-3.2c-0.4-1.3-1.6-2.2-3-2.2h-2.1c-1.7,0-3.2,1.4-3.2,3.2s1.4,3.2,3.2,3.2
      h2.1c1.4,0,2.6-0.9,3-2.2h3.2c2,0,3.6-1.6,3.6-3.6v-2.2C33.8,27.5,36,25.3,36,22.6z M9.4,25.6c-1.6-0.1-2.9-1.4-2.9-3
      c0-1.6,1.3-2.9,2.9-3V25.6z M21.3,33.5h-2.1c-0.6,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2h2.1c0.6,0,1.2,0.5,1.2,1.2S22,33.5,21.3,33.5z
      M31.1,25.6v-6c1.6,0.1,2.9,1.4,2.9,3C34,24.2,32.7,25.5,31.1,25.6z"
    />
    <path
      d="M19.9,27.1c0.3,0,0.5-0.1,0.7-0.3l3.8-3.8c0.7-0.7,1.1-1.6,1.1-2.6c0-1-0.4-1.9-1.1-2.6
      c-1.2-1.2-3.1-1.4-4.5-0.5c-1.4-0.9-3.3-0.7-4.5,0.5c-1.4,1.4-1.4,3.7,0,5.1c0,0,0,0,0,0s0,0,0,0l3.7,3.7
      C19.4,27,19.7,27.1,19.9,27.1z M16.9,21.7C16.9,21.7,16.9,21.7,16.9,21.7c-0.7-0.7-0.7-1.7,0-2.3c0.6-0.6,1.7-0.6,2.3,0
      c0.2,0.2,0.5,0.3,0.8,0.3s0.5-0.1,0.7-0.3c0.6-0.6,1.7-0.6,2.3,0c0.6,0.6,0.6,1.7,0,2.3l-3.1,3.1L16.9,21.7
      C16.9,21.7,16.9,21.7,16.9,21.7z"
    />
  </IconBase>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Icons/Support.jsx